import { httpsCallable } from "firebase/functions";
import { cloudFunctions } from "./getFunctions";
import {
  CloudFunctionResponse,
  CallablesGeneral,
  oAuthGoogleGuardarToken
} from "@fixeduy/restaurantestypes";

const oAuthGoogleGuardarTokenLectorMailsFunction = async (
  params: oAuthGoogleGuardarToken
): Promise<CloudFunctionResponse> => {
  const run = httpsCallable<CallablesGeneral, CloudFunctionResponse>(
    cloudFunctions,
    "callablesGenerales"
  );
  const result = await run({
    func: "oAuthGoogleGuardarTokenLectorMails",
    params: params
  });
  return result.data;
};

export { oAuthGoogleGuardarTokenLectorMailsFunction };
